import React from "react";
import { company } from "../mock/mock";
import { PageHero } from "../components/Common";

const sections = [
  {
    title: "Privacy Policy",
    body: "No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. All categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.",
  },
  {
    title: "SMS & Communications Disclaimer",
    body: "By providing your phone number to Mid Atlantic Business Management Inc, you agree and acknowledge that we may send text messages to your wireless phone number for any purpose. Message and data rates may apply. We will only send one SMS as a reply to you, and you will be able to opt-out by replying STOP.",
  },
  {
    title: "Cookies",
    body: "We use cookies to analyze website traffic and optimize your website experience. By accepting our use of cookies, your data will be aggregated with all other user data. You may decline non-essential cookies at any time.",
  },
  {
    title: "Compliance",
    body: "Mid Atlantic Business Management Inc is compliant with local business laws and regulations. Our healthcare programs are 100% HIPAA compliant across staff, processes and technology.",
  },
  {
    title: "Refund & Guarantee",
    body: "We stand behind our service with a 30-day money-back guarantee. If you are not satisfied within the first 30 days of your engagement, contact us to discuss your options.",
  },
];

const Policies = () => {
  return (
    <div>
      <PageHero eyebrow="Legal" title="Policies" subtitle="Our commitment to transparency, privacy and compliance." />
      <section className="bg-white py-20">
        <div className="max-w-3xl mx-auto px-6 space-y-10">
          {sections.map((s) => (
            <div key={s.title}>
              <h2 className="font-heading font-bold text-navy text-xl mb-3">{s.title}</h2>
              <p className="text-muted-foreground leading-relaxed">{s.body}</p>
            </div>
          ))}
          <div className="pt-8 border-t border-border text-sm text-muted-foreground">
            <p>{company.name} — also doing business as Midatlantic B2B.</p>
            <p>{company.addressUS}</p>
            <p>{company.phone} &middot; {company.email}</p>
            <p className="mt-4">© 2018-2026 Mid Atlantic Business Management Inc — All Rights Reserved.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Policies;
